export default __webpack_public_path__ + "static/media/vicko.f7e17f91.jpeg";